const REDACTED_HISTORY_VALUE = /^\[redacted - \d+ chars\]$/;

// Placeholder the Time Machine diagnostic redactor writes in place of a masked value.
export const isRedactedHistoryValue = (value) => typeof value === 'string' && REDACTED_HISTORY_VALUE.test(value);
